<template>
    <div class="functionListDiv">
        <div class="functionListTab">
            <Tabs :value="Tab.CurrentName">
                <TabPane :label="item.label" :name="item.name" v-for="(item,index) in Tab.List" :key="index">
                    <!--<BusinessExpandingForm :currentPage="item.name" v-if="item.name=='yhfzxz_qy'||item.name=='yhfzgz_qy'"></BusinessExpandingForm>-->
                    <BusinessForm :currentPage="item.name"></BusinessForm>
                </TabPane>
            </Tabs>
            <Spin size="large" fix v-if="SpinShow"></Spin>
        </div>
        <div class="footerArea">© 2020 马鞍山首创水务有限责任公司 All Rights Reserved</div>
    </div>
</template>

<script>
    import BusinessForm from './BusinessForm';
    // import BusinessExpandingForm from './BusinessExpandingForm';
    export default {
        name: 'BusinessLayout_DW',
        components:{
            BusinessForm,
           // BusinessExpandingForm
        },
        data() {
            return {
                Tab:{
                    CurrentName:"ghsq_qy",
                    List:[
                        {name:"yhfzxz_qy",label:"接水申请"},
                        {name:"ghsq_qy",label:"水表过户"},
                        {name:"zxsq_qy",label:"水表销户"},
                    ]
                },
                SpinShow:false,
            }
        },
        created() {
            this.Tab.CurrentName=this.$route.query.currentPage;
        },
        methods: {

        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    h3{
        font-size: 14px;
    }
    .ivu-row{
        margin-left: 16px!important;
        margin-right: 16px!important;
    }
    .txtClass h3{
        padding:10px 0
    }
    .contentArea .iconBlock{
        width:8px;
        height:20px;
        background:#f90;
        position: absolute;
        top:20px;
        left:0
    }
    .contentArea h3{
        text-align: left;
        font-size:18px;
    }
    .txtClass .iconBlock{
        width:8px;
        height:20px;
        background:#2EB4E9;
        position: absolute;
        top:10px;
        left:0
    }
    .submitBtn{
        padding-top:10px;
    }
    .formArea{
        padding-top:30px;
    }
    .ivu-form-item{
        text-align: left!important;
    }
    /*上传图片*/
    .demo-upload-list{
        display: inline-block;
        width: 60px;
        height: 60px;
        text-align: center;
        line-height: 60px;
        border: 1px solid transparent;
        border-radius: 4px;
        overflow: hidden;
        background: #fff;
        position: relative;
        box-shadow: 0 1px 1px rgba(0,0,0,.2);
        margin-right: 4px;
    }
    .demo-upload-list img{
        width: 100%;
        height: 100%;
    }
    .demo-upload-list-cover{
        display: none;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: rgba(0,0,0,.6);
    }
    .demo-upload-list:hover .demo-upload-list-cover{
        display: block;
    }
    .demo-upload-list-cover i{
        color: #fff;
        font-size: 20px;
        cursor: pointer;
        margin: 0 2px;
    }

    .explainTXT{
        text-align: left
    }
    .explainTXT p{
        line-height:32px;
    }

</style>
